import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContattiRoutingModule } from './contatti-routing.module';
import { ContattiComponent } from './contatti.component';

import { FormsModule } from '@angular/forms';
import { ContattoViewComponent } from './contatto-view/contatto-view.component';
import { ContattiCreateComponent } from './contatti-create/contatti-create.component';
import { ContattiEditComponent } from './contatti-edit/contatti-edit.component';
import { ContattiDetailsComponent } from './contatti-details/contatti-details.component';
import { ContattiListComponent } from './contatti-list/contatti-list.component';
import { ContattiFormComponent } from './contatti-form/contatti-form.component';
import { NewMapsModule } from '../new-maps/new-maps.module';
import { AddressModule } from '../address/address.module';
import { MyCustomMaterialModule } from 'san-common';



@NgModule({
  declarations: [
    ContattiComponent,
    ContattoViewComponent,
    ContattiCreateComponent,
    ContattiEditComponent,
    ContattiDetailsComponent,
    ContattiListComponent,
    ContattiFormComponent,
    
    ],
  imports: [
    CommonModule,
    ContattiRoutingModule,
    FormsModule,
    MyCustomMaterialModule,
    AddressModule,NewMapsModule
  ],
  exports: [ContattiComponent,
    ContattoViewComponent,
    ContattiCreateComponent,
    ContattiEditComponent,
    ContattiDetailsComponent,
    ContattiListComponent,
    ContattiFormComponent,
    
  ]
})
export class ContattiModule { }
